import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const fieldLabel: AbgSxProps = {
  fontWeight: '500',
  mb: 1,
  color: paletteBase.black,
};

export const inputField: AbgSxProps = {
  '& input': {
    py: '10px',
    color: paletteBase.black,
  },
};

export const containerStyle: AbgSxProps = {
  mt: 3,
};
